<template>
  <a-modal
    :title="!editId ? $t('message[1732]') : $t('message[1733]')"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :mask-closable="false"
    :width="620"
    wrap-class-name="autoWithdraw-rule-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p class="prompt">
      {{ $t('message[1734]') }}
    </p>
    <a-form
      ref="form"
      :form="form"
    >
      <RuleItemGroup
        ref="ruleGroupRef"
        :rule-value="ruleValue"
        :base-info-child="baseInfoChild"
        @change="handleChangeRuleCondition"
      />
      <a-form-item
        :label="`${$t('message[1749]')}：`"
        class="type-item"
        :class="{'isEnglish': $isEnglish}"
      >
        <a-select
          :value="type"
          @change="handleChangeType"
        >
          <a-select-option
            v-for="option in typeOptions"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </a-select-option>
        </a-select>
        <span class="text">{{ currentText }}</span>
      </a-form-item>
      <a-form-item>
        <div slot="label">
          <a-popover>
            <template slot="content">
              <p>{{ $t('message[1737]') }}</p>
            </template>
            <i class="iconfont iconicon-test68 fs-gray" />
          </a-popover>
          {{ $t('message[1738]') }}
        </div>
        <a-checkbox-group
          :value="resetKeys"
          :options="resetOptions"
          @change="onChangeReset"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import RuleItemGroup from './RuleItemGroup'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'AutoWithdrawRuleMoadl',
  components: {
    RuleItemGroup
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editId: {
      type: [String, Number],
      default: ''
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      type: 2,
      resetKeys: [],
      ruleValue: {},
      // 2待分配  3待指派  4共享信息  5已归档
      typeOptions: [{
        id: 2,
        key: 'assigned',
        name: this.$t('message[139]'), // '待分配'
        text: this.$t('message[1739]') // 可重新分配
      }, {
        id: 3,
        key: 'designated',
        name: this.$t('message[146]'), // '待指派'
        text: this.$t('message[1740]') // 可由组长重新指派
      }, {
        id: 4,
        key: 'shared',
        name: this.$t('message[394]'), // '共享信息'
        text: this.$t('message[1741]') // 可由小组成员共享
      }, {
        id: 5,
        key: 'archived',
        name: this.$t('message[1460]'), // '已归档'
        text: this.$t('message[1742]') // 可归档放置
      }],
      baseInfoChild: []
    }
  },

  computed: {
    ...mapState(['baseinfo']),
    ...mapState('config/autoWithdraw', ['ruleCondition']),

    currentText () {
      let currItem = this.typeOptions.find(item => item.id === this.type)
      return (currItem && currItem.text) || ''
    },
    resetOptions () {
      let arr = this.baseInfoChild.map(item => {
        return {
          value: item.fieldkey,
          label: item.fieldname
        }
      })
      return arr
    },
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    }
  },

  watch: {
    visible: {
      handler (val) {
        let { editId } = this
        if (!this.visible) {
          editId = undefined
        }

        this.setDetailData(editId)
      },
      immediate: true
    }
  },
  created () {
    this.typeOptions = this.typeOptions.filter(item => (item.key === 'shared' && this.enableshare) || item.key !== 'shared')
  },

  methods: {
    ...mapActions('config/autoWithdraw', ['addRecycle', 'fetchRuleCondition']),
    ...mapMutations('config/autoWithdraw', ['setRuleCondition']),

    async setDetailData (id) {
      let params = {}
      if (id) {
        params.id = id
      }
      let chain = await this.fetchRuleCondition(params)
      chain
        .onSuccess(res => {
          let { info = {} } = res || {}
          this.type = info.reset_status || 2
          this.ruleValue = info.rule || {}
          this.resetKeys = info.reset_field || []

          this.baseInfoChild = this.setBaseInfoChild()
        })
    },
    setBaseInfoChild () {
      if (!this.ruleCondition) return

      let { allConfig = {} } = this.ruleCondition || {}
      let { base_info: baseInfo = {} } = allConfig
      let { child = [] } = baseInfo
      child = Object.values(child)
      child = child.filter(item => item.fieldtype !== 'radioinfo_payfor')
      child.forEach(item => {
        let { fieldtype, options = [], fieldconfig } = item || {}
        if (fieldtype === 'radioinfo_level') {
          item.options = this.LevelOption(options, fieldconfig)
        }
        this.$set(item, 'fieldvalue', undefined)
      })

      return child
    },
    LevelOption (options, fieldconfig) {
      const { type } = fieldconfig
      let arr = []

      if (type === 1) {
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      } else if (type === 2) {
        let str = this.$t('message[1444]')
        arr = str.split(',')
        // arr = ['一星', '二星', '三星', '四星', '五星', '六星', '七星']
      }

      options.forEach((item, index) => {
        arr.forEach((code, i) => {
          if (index === i) {
            item.name = code
          }
        })
      })

      return options
    },

    handleChangeType (val) {
      this.type = val
    },
    onChangeReset (val) {
      this.resetKeys = val
    },
    handleChangeRuleCondition (res) {
      this.ruleValue = res
    },
    hide () {
      this.ruleValue = {}
      this.type = 2
      this.resetKeys = []
      // 清空获取的接口数据
      this.setRuleCondition(null)
      this.form.resetFields()
      this.$emit('update:visible', false)
    },
    handleOk () {
      this.$refs.ruleGroupRef.checkRuleGroup()
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            rule: this.ruleValue,
            reset_field: this.resetKeys,
            reset_status: this.type
          }
          if (this.editId) {
            params.id = this.editId
          }
          this.confirmRecycle(params)
        }
      })
    },
    async confirmRecycle (params) {
      if (this.confirmLoading) return
      this.confirmLoading = true

      let _this = this
      let chain = await this.addRecycle(params)
      chain
        .config({
          error102 (raw = {}) {
            let { payload = [] } = raw
            let { message = '' } = payload[0]
            _this.$message && _this.$message.destroy()
            _this.$message.error(message)
          }
        })
        .onNetSuccess(res => {
          this.confirmLoading = false
        })
        .onSuccess(res => {
          this.hide()
        })
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>
<style scoped lang="scss">
.prompt {
  min-height:40px;
  line-height: 40px;
  margin-bottom: 24px;
  padding: 0 24px;
  color: #4CA0F2;
  background:#E8F4FF;
}
.ant-form {
  padding: 0 40px;
}
::v-deep .ant-form-item-label {
  float: left;
  width: 120px;
  padding-right: 26px;
  label {
    position: relative;
    display: inline-block;
    color: #666;
    &::after {
      position: absolute;
      top: 0;
    }
  }
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 120px;
}
::v-deep .ant-form-item-children {
  display: block;
}
.type-item {
  .ant-select {
    width: 160px;
  }
  .text {
    margin-left: 4px;
  }
  &.isEnglish ::v-deep{
     .ant-form-item-label {
       width: 200px;
     }
  }
}

</style>
<style lang="scss">
.autoWithdraw-rule-modal {
  .ant-modal-body {
    padding: 0;
    max-height: 468px;
    overflow-y: scroll;
  }
}
</style>
